import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

import '~/style.sass'

const application = Application.start()
const controllers = import.meta.globEager('./../**/*_controller.js')
registerControllers(application, controllers)

import * as Turbo from '@hotwired/turbo'
Turbo.start()

document.addEventListener('turbo:frame-load', () => {
  document.querySelectorAll('[tippy]').forEach(element => {
    const content = element.getAttribute('tippy')
    tippy(element, { 
      content: content,
      interactive: true,
      allowHTML: true,
      trigger: 'click',
      onShow: () => {
        // send plausible event
        if (window.plausible) {
          window.plausible('Tooltip', { props: { content: content } })
        }
      }
    });
  });
})


document.addEventListener('turbo:submit-start', (event) => {
  console.log("turbo submit start", event.detail)

  if (document.location.pathname.includes('admin_area')) {
    console.log("ESCO")
    return
  }

  // disable submit button
  var nodeToDisable = event.target.querySelector('a')
  if (nodeToDisable) {
    nodeToDisable.style.pointerEvents = 'none'
    nodeToDisable.style.cursor = 'wait'
    // replace with custom loader
    nodeToDisable.innerHTML = '🐲 ....'
  }

  // cerca il nodo anti spam e popolalo
  var form = event.detail.formSubmission.formElement
  var nodeToFill = form.querySelector('input[name="g-recaptcha-response"]')

  if (!nodeToFill) {
    console.log("nessun nodo anti spam; quindi non posso procedere, esco!", nodeToFill)
    return
  }

  if (nodeToFill.value) {
    console.log("anti spam già popolato; esco!", nodeToFill)
    return
  }

  console.log("nodo PRESENTE!! 🥳", "inizio dialogo con grecaptha")
  event.detail.formSubmission.stop()
  grecaptcha.execute('6LcCcjQpAAAAAF95aLbbMvTtIgmxbZCXaGXDrfwn', {action: 'submit'}).then(function(token) {
    console.log("ESEGUO!")
    nodeToFill.value = token
    event.target.querySelector('input[type="submit"]').click()
  });
})